export default __webpack_public_path__ + "static/media/microVoice.a4ceb760.svg";